import { initialState } from './data-access.state';
import * as EvidenceActions from './data-access.actions';
import { createReducer, on } from '@ngrx/store';
import { EvidenceStatus } from '@shared/utils/evidence-management';
import { ActionType, EvidenceDetailsActionResult } from '../models/evidence-action-result.models';

export const evidenceReducer = createReducer(
  initialState,

  on(EvidenceActions.clearState, () => {
    return {
      ...initialState,
    };
  }),
  on(EvidenceActions.getEvidenceSuccess, (state, action) => {
    return {
      ...state,
      evidenceUid: action.evidenceAndPreview.evidence.uid,
      evidenceAndPreview: action.evidenceAndPreview,
      isLoading: false,
      isLocationLoading: action.evidenceAndPreview.evidence.status === EvidenceStatus.Active,
      isLockCodeRequired: false,
    };
  }),
  on(EvidenceActions.getEvidence, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(EvidenceActions.getEvidenceLocationSuccess, (state, payload) => {
    return {
      ...state,
      location: payload.location,
      isLocationLoading: false,
    };
  }),
  on(EvidenceActions.toggleLockEvidence, (state) => {
    if (state.evidenceAndPreview) {
      return {
        ...state,
        evidenceAndPreview: { ...state.evidenceAndPreview, evidence: { ...state.evidenceAndPreview.evidence, isLocked: !state.evidenceAndPreview.evidence.isLocked } },
      };
    }

    return state;
  }),
  on(EvidenceActions.setEvidenceUid, (state, action) => {
    return {
      ...state,
      evidenceUid: action.uid,
    };
  }),
  on(EvidenceActions.updateEvidence, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(EvidenceActions.updateEvidenceSuccess, (state, action) => {
    if (state.evidenceAndPreview) {
      return {
        ...state,
        evidenceAndPreview: { ...state.evidenceAndPreview, evidence: action.evidenceDetails },
        actionResult: new EvidenceDetailsActionResult(ActionType.UpdateEvidenceDetails, null, true),
        isLoading: false,
      };
    }

    return state;
  }),
  on(EvidenceActions.updateEvidenceActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
      isLoading: false,
    };
  }),
  on(EvidenceActions.updateEvidenceLocationSuccess, (state, payload) => {
    return {
      ...state,
      location: payload.location,
      actionResult: new EvidenceDetailsActionResult(ActionType.UpdateEvidenceLocation, null, true),
    };
  }),
  on(EvidenceActions.getEvidenceLinksSuccess, (state, payload) => {
    return {
      ...state,
      links: payload.evidenceLinks,
    };
  }),
  on(EvidenceActions.setUpEvidenceDetails, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(EvidenceActions.setUpEvidenceDetailsSuccess, (state, payload) => {
    if (state.evidenceAndPreview) {
      return {
        ...state,
        evidenceAndPreview: { ...state.evidenceAndPreview, evidence: payload.evidenceDetails },
        isLoading: false,
      };
    }

    return state;
  }),
  on(EvidenceActions.setLockCodeRequired, (state, payload) => {
    return {
      ...state,
      isLockCodeRequired: payload.required,
    };
  }),
  on(EvidenceActions.revertEvidence, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(EvidenceActions.setAiSummaryStatus, (state, payload) => {
    if (state.evidenceAndPreview) {
      return {
        ...state,
        evidenceAndPreview: {
          ...state.evidenceAndPreview,
          evidence: {
            ...state.evidenceAndPreview.evidence,
            aiSummaryStatus: payload.aiSummaryStatus,
          },
        },
      };
    }

    return state;
  }),
  on(EvidenceActions.updateTranscriptionStatus, (state, payload) => {
    if (state.evidenceAndPreview) {
      return {
        ...state,
        evidenceAndPreview: {
          ...state.evidenceAndPreview,
          evidence: {
            ...state.evidenceAndPreview.evidence,
            transcriptionStatus: payload.status,
          },
        },
      };
    }

    return state;
  })
);
